import { LGraphNode, LiteGraph } from "litegraph.js";

export class FontPickerNode extends LGraphNode {
    constructor() {
        super();
        this.title = "Font Picker";
        this.fonts = ["Frame", "Hairline"];

        this.mode = LiteGraph.ALWAYS;

        this.addOutput("Font 1", "string");
        this.addOutput("Font 2", "string");

        this.size = [200, 80];
        this.color = "#2a2a2a";
        this.bgcolor = "#333333";
    }

    onExecute() {
        this.setOutputData(0, this.fonts[0]);
        this.setOutputData(1, this.fonts[1]);
    }

    onDrawForeground(ctx) {
        const pad = 10;
        // Draw font samples below the output slots
        const y1 = 34;
        const y2 = 62;

        ctx.fillStyle = "rgba(255,255,255,0.85)";
        ctx.font = `22px ${this.fonts[0]}`;
        ctx.fillText(this.fonts[0], pad, y1);

        ctx.fillStyle = "rgba(255,255,255,0.5)";
        ctx.font = `22px ${this.fonts[1]}`;
        ctx.fillText(this.fonts[1], pad, y2);
    }
}

LiteGraph.registerNodeType("custom/font_picker", FontPickerNode);
